module.exports = __webpack_public_path__ + "img/team-icon.4e29fcdd.png";